import React, { useState } from 'react';
import { Triangle } from './carbon';
import { Box, Row, Heading } from './core';
import type { BoxProps } from 'theme-ui';

interface CollapseProps extends BoxProps {
  heading: string;
  disabled?: boolean;
}

export const Collapse = ({
  heading,
  disabled,
  children,
  as = 'h2',
  ...more
}: CollapseProps): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Box {...more}>
      <Row
        onClick={() => !disabled && setOpen(!open)}
        color={disabled ? 'muted' : 'primary'}
        sx={{ alignItems: 'center', cursor: disabled ? 'default' : 'pointer' }}
      >
        <Triangle
          mr={2}
          sx={{
            width: '.8em',
            height: '.8em',
            fill: 'currentColor',
            transform: open ? 'none' : 'rotate(-90deg)',
          }}
        />
        <Heading as={as}>{heading}</Heading>
      </Row>
      {open && !disabled && <Box>{children}</Box>}
    </Box>
  );
};
